import DefaultLayout from './default.vue';
import SimpleLayout from './simple.vue';

export default {
  default: DefaultLayout,
  simple: SimpleLayout,
};
